// src/components/dfs/skeletons/MatchCardSkeleton.tsx
import React from 'react';

const MatchCardSkeleton: React.FC = () => {
  return (
    <div className="flex-shrink-0 w-[110px] h-[38px] bg-primary-dark rounded border border-gray-700 animate-pulse" />
  );
};

export default MatchCardSkeleton;
